import { render, staticRenderFns } from "./ChatFaceTile.vue?vue&type=template&id=d989ec80&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatFaceTile.vue"
export default component.exports